module.exports = __webpack_public_path__ + "static/media/IMPORT_BULK_UPLOAD_VAT_PARTNER_3.00.015a0f43.xlsx";